<template>
	<div class="tabBar">
		<van-tabbar
			v-model="newActive"
			active-color="#0245bf"
			inactive-color="#000"
		>
			<van-tabbar-item
				v-for="(item, index) in tabData"
				:key="index"
				:to="item.path ? item.path : item.url"
				:replace="item.replace"
				@click.capture.stop="changeTab"
			>
				<span>{{ item.name }}</span>
				<img
					slot="icon"
					slot-scope="props"
					:src="props.active ? item.activeIcon : item.normalIcon"
				/>
			</van-tabbar-item>
		</van-tabbar>
	</div>
</template>

<script>
import { Toast } from "vant";
export default {
	name: "TabBar",
	props: {
		active: Number,
	},
	data() {
		return {
			newActive: "",
			items: [
				{
					name: "首页",
					path: "/home",
					normalIcon: require("../../image/house.png"),
					activeIcon: require("../../image/house_c.png"),
					replace: false,
				},
				{
					name: "扫码核销",
					url: "",
					scanMode: true,
					normalIcon: require("../../image/saoma.png"),
					activeIcon: require("../../image/saoma_c.png"),
					replace: false,
				},
				{
					name: "我的",
					path: "/mine/shop",
					normalIcon: require("../../image/me.png"),
					activeIcon: require("../../image/me_c.png"),
					replace: false,
				},
			],
		};
	},
	computed: {
		tabData() {
			console.log(this.$global.routes)
			const scanEnabled =
				this.$global.routes.indexOf("/couponVerificationInHomeTabbar") >= 0;
			let data = [
				{
					name: "首页",
					path: "/home",
					normalIcon: require("../../image/house.png"),
					activeIcon: require("../../image/house_c.png"),
					replace: false,
				},
			];
			if (true) {
				data.push({
					name: "扫码核销",
					url: "",
					scanMode: true,
					normalIcon: require("../../image/saoma.png"),
					activeIcon: require("../../image/saoma_c.png"),
					replace: false,
				});
			}
			data.push({
				name: "我的",
				path: "/mine/shop",
				normalIcon: require("../../image/me.png"),
				activeIcon: require("../../image/me_c.png"),
				replace: false,
			});
			return data;
		},
	},
	mounted() {
		this.$wechartfunc();
		this.newActive = this.active;
	},
	methods: {
		async changeTab() {
			const active = this.newActive
			const item = this.tabData[active];
			if (item.scanMode) {
				/* if (!this.scanEnabled) {
					Toast.fail("账号未开启核销权限!");
					return;
				} */
				
				if(window.location.host.indexOf('localhost') >= 0){
					this.$router.push({
						path: `/couponVerification/searchDetail`,
						query: {
							sancode: '4448114281242444824',
						},
					});
					return;
				}
				const scanQRCode = await this.$wechartfunc("scanQRCode");
				if (scanQRCode) {
					this.$router.push({
						path: `/couponVerification/searchDetail`,
						query: {
							sancode: scanQRCode,
						},
					});
				}
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.icons {
	.van-swipe {
		padding: px2rem(40);
		.icon {
			float: left;
			width: 22%;
			height: px2rrem(240);
			padding-top: px2rem(25);
			text-align: center;
			.icon-img {
				width: px2rem(100);
				height: px2rem(100);
				display: inline-block;
				img {
					border-radius: 50%;
				}
				.img-content {
					width: px2rem(100);
					height: px2rem(100);
					background: 0;
				}
			}
			::v-deep .van-tabbar-item__icon img {
				height: 1.3rem !important;
			}
			.keywords {
				margin: px2rem(20) 0;
				color: #fff;
				overflow: hidden;
				white-space: nowrap;
				text-overflow: ellipsis;
				font-size: px2rem(28);
			}
		}
	}
}
</style>